{
  "name": "@ns/support-behaviour-score-failing",
  "version": "1.0.0",
  "description": "A published company's behaviour score has failed to work out several nights in a row: find out why, score it again, then mark it resolved",
  "inputs": {
    "subjectCompanyId": {
      "type": "string"
    },
    "subjectCompanyName": {
      "type": "string"
    },
    "failingSince": {
      "type": "string"
    },
    "failingReason": {
      "type": "string"
    },
    "failedAttempts": {
      "type": "string"
    }
  },
  "outcomes": {
    "resolved": {}
  }
}
